import { z } from "zod";

export function getEditPatientSchema() {
  return z.object({
    rut: z.string().nullable().default(null),
    passport: z.string().nullable().default(null),
    name: z
      .string()
      .min(1, "Debes escribir el nombre del paciente.")
      .transform((s) => s.trim()),
    firstSurname: z
      .string()
      .min(1, "Debes escribir el apellido paterno del paciente.")
      .transform((s) => s.trim()),
    secondSurname: z
      .string()
      .min(1, "Debes escribir el apellido materno del paciente.")
      .transform((s) => s.trim()),
    birthdate: z.string().min(1, "Debes ingresar la fecha de nacimiento del paciente."),
    weight: z
      .union([z.string(), z.number()])
      .nullable()
      .optional()
      .transform((v) => {
        if (v == null) return null;
        const s = String(v).trim();

        return s === "" ? null : s;
      }),
    email: z
      .string()
      .min(1, "Debes escribir el correo electrónico del paciente.")
      .email("El correo electrónico está incompleto")
      .transform((s) => s.toLowerCase().trim()),
    phone: z.string(),
    region: z.string().min(1, "Debes seleccionar la región del paciente."),
    commune: z.string().min(1, "Debes seleccionar la comuna del paciente."),
    street: z
      .string()
      .min(1, "Debes escribir la dirección del paciente.")
      .transform((s) => s.trim()),
  });
}

/** The first message the schema gives for each invalid field, as the form shows it. */
export function firstErrorPerField(error: z.ZodError) {
  return Object.entries(z.flattenError(error).fieldErrors).map(
    ([field, messages]) =>
      [field, Array.isArray(messages) ? messages[0] : messages] as const,
  );
}
